var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehanceLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 34,
    viewBox: "0 0 52 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6667 5.16671H32.5V0.833374H47.6667V5.16671ZM51.4063 26.8334C50.4487 29.6435 47.0102 33.3334 40.3542 33.3334C33.6938 33.3334 28.2988 29.5872 28.2988 21.0375C28.2988 12.5659 33.3363 8.21087 40.1418 8.21087C46.8195 8.21087 50.8972 12.0719 51.7877 17.8005C51.9567 18.8969 52.0238 20.3745 51.9935 22.4372H34.6017C34.8833 29.3944 42.1482 29.6132 44.5423 26.8334H51.4063ZM34.7533 18.1667H45.5108C45.2833 14.8149 43.0495 13.3589 40.144 13.3589C36.9677 13.3589 35.2105 15.0229 34.7533 18.1667ZM14.0097 33.3074H0V0.878874H15.0648C26.9295 1.05437 27.1548 12.6742 20.9582 15.8419C28.457 18.5719 28.7083 33.3074 14.0097 33.3074ZM6.5 13.8334H14.2653C19.6993 13.8334 20.5617 7.33337 13.5893 7.33337H6.5V13.8334ZM13.8472 20.3334H6.5V26.868H13.7388C20.358 26.868 19.9528 20.3334 13.8472 20.3334Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceLogo);
export default __webpack_public_path__ + "static/media/behance-logo.334577623ea3572c23867394150f47d5.svg";
export { ForwardRef as ReactComponent };